import { apiClient } from './api-client';

// GET /me/notifications 응답 항목 (api NotificationResponse). 생성 타입 재생성은 무관 라우트 diff가 섞여 수기로 둔다.
export interface NotificationItem {
  id: number;
  title: string;
  body: string | null;
  /** 앱 내부 라우트 경로(orgCode 프리픽스 없음). null 이면 이동 없는 통보 */
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export const notificationClient = {
  async list(): Promise<NotificationItem[]> {
    const res = await apiClient
      .get('me/notifications', { searchParams: { size: 20 } })
      .json<{ result?: NotificationItem[] }>();
    return res.result ?? [];
  },
  async unreadCount(): Promise<number> {
    const res = await apiClient.get('me/notifications/unread-count').json<{ result?: number }>();
    return res.result ?? 0;
  },
  async markRead(id: number): Promise<void> {
    await apiClient.patch(`me/notifications/${id}/read`);
  },
  async markAllRead(): Promise<void> {
    await apiClient.patch('me/notifications/read-all');
  },
};
